var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: _vm.classes, attrs: { tabindex: "-1", role: "dialog" } },
    [
      _c(
        "div",
        { staticClass: "modal-content", class: { container: !_vm.size } },
        [
          _c(
            "div",
            { staticClass: "modal-header" },
            [
              _vm.close
                ? _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button", disabled: !_vm.closeEnabled },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_vm._v("×")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("title", function () {
                return [
                  _c("h4", { staticClass: "modal-title" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ]),
                ]
              }),
              _vm._v(" "),
              _vm._t("header"),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [_vm._t("body"), _vm._v(" "), _vm._t("default")],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-footer" },
            [
              _vm._t("footer"),
              _vm._v(" "),
              _vm.close
                ? _c(
                    "button",
                    {
                      staticClass: "btn",
                      class: _vm.closeClass,
                      attrs: { type: "button", disabled: !_vm.closeEnabled },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.closeMessage))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.confirm
                ? _c(
                    "button",
                    {
                      staticClass: "btn",
                      class: _vm.confirmClass,
                      attrs: { type: "button", disabled: !_vm.confirmEnabled },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("confirm")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.confirmMessage))]
                  )
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }